import { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { AiTranslateModal } from '@/components/AiTranslateModal';

interface Props {
  targetLang: string;
}

export function BulkTranslateButton({ targetLang }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Tooltip title={`Bulk AI Translate all missing keys for ${targetLang}`}>
        <Button type="primary" icon={<ThunderboltOutlined />} onClick={() => setOpen(true)}>
          Bulk AI Translate
        </Button>
      </Tooltip>
      <AiTranslateModal open={open} defaultTargetLang={targetLang} onClose={() => setOpen(false)} />
    </>
  );
}
